
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3cbd839a&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DiscussionStudentTab.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DiscussionStudentTab.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3cbd839a!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DiscussionStudentTab.vue"),
  /* scopeId */
  "data-v-3cbd839a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/courses/pages/Reports/DiscussionStudentTab.vue
// module id = 458
// module chunks = 61